const CHUNK_RELOAD_KEY = 'hs-med-billing:chunk-reload-at';
const CHUNK_RELOAD_WINDOW_MS = 60_000;

type RecoveryStorage = Pick<Storage, 'getItem' | 'setItem'>;
type RecoveryBrowser = {
  readonly location: Pick<Location, 'reload'>;
  readonly sessionStorage: RecoveryStorage;
};

export function isChunkLoadError(error: Error): boolean {
  const details = `${error.name} ${error.message}`;

  return /ChunkLoadError|Loading chunk \d+ failed/i.test(details);
}

export function shouldReloadForChunkError(
  error: Error,
  storage: RecoveryStorage,
  now = Date.now()
): boolean {
  if (!isChunkLoadError(error)) {
    return false;
  }

  try {
    const storedAttempt = storage.getItem(CHUNK_RELOAD_KEY);
    const lastAttemptAt = storedAttempt ? Number(storedAttempt) : null;

    if (
      lastAttemptAt !== null &&
      Number.isFinite(lastAttemptAt) &&
      now - lastAttemptAt < CHUNK_RELOAD_WINDOW_MS
    ) {
      return false;
    }

    storage.setItem(CHUNK_RELOAD_KEY, String(now));
    return true;
  } catch {
    return false;
  }
}

export function recoverFromChunkLoadError(
  error: Error,
  browser: RecoveryBrowser,
  now = Date.now()
): boolean {
  if (!isChunkLoadError(error)) {
    return false;
  }

  try {
    if (!shouldReloadForChunkError(error, browser.sessionStorage, now)) {
      return false;
    }

    browser.location.reload();
    return true;
  } catch {
    return false;
  }
}
